module.exports = __webpack_public_path__ + "2345038ae3c4760cfcaf01e04897d1f8.jpg";